import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(400px);
    opacity: 0;
  }
`;

export const NotificationBox = styled.div`
  position: fixed;
  right: 20px;
  top: 80px;
  width: 380px;
  max-width: calc(100vw - 40px);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 768px) {
    width: calc(100vw - 40px);
    right: 20px;
  }
`;

export const NotificationItem = styled.div<{ type: string; isExiting?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  animation: ${props => props.isExiting ? fadeOut : slideIn} 0.3s ease-out;
  position: relative;
  overflow: hidden;
  border-left: 4px solid;
  
  background: ${props => {
    switch (props.type) {
      case 'SUCCESS':
        return 'linear-gradient(135deg, rgba(40, 167, 69, 0.95) 0%, rgba(32, 201, 151, 0.95) 100%)';
      case 'DANGER':
        return 'linear-gradient(135deg, rgba(220, 53, 69, 0.95) 0%, rgba(200, 35, 51, 0.95) 100%)';
      default:
        return 'linear-gradient(135deg, rgba(0, 123, 255, 0.95) 0%, rgba(0, 86, 179, 0.95) 100%)';
    }
  }};
  
  border-left-color: ${props => {
    switch (props.type) {
      case 'SUCCESS':
        return '#20c997';
      case 'DANGER':
        return '#c82333';
      default:
        return '#0056b3';
    }
  }};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
    pointer-events: none;
  }
`;

export const IconWrapper = styled.div<{ type: string }>`
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  flex-shrink: 0;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: white;
  letter-spacing: 0.3px;
`;

export const Message = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.4;
  word-wrap: break-word;
`;

export const CloseButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  font-size: 20px;
  line-height: 1;
  padding: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: rotate(90deg);
  }

  &:active {
    transform: scale(0.9) rotate(90deg);
  }
`;

export const ProgressBar = styled.div<{ duration: number }>`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.4);
  animation: shrink ${props => props.duration}ms linear;

  @keyframes shrink {
    from {
      width: 100%;
    }
    to {
      width: 0%;
    }
  }
`;
